import { NoteDTO } from 'common/utils/util.type';
import { get, post, put } from '../../common/axiosClient';
import { API } from '../../common/constants/urls';
import { Division, LineItem, LineItemForPrediction } from './glossary.type';

export const getDivisions = async () => {
  return (await get(`${API.DIVISIONS}`)) as Division[];
};
export const getReportDivisions = async (reportId: string) => {
  return (await get(`${API.DIVISIONS}/Report/${reportId}`)) as Division[];
};

export const getLineItem = async (id: string) => {
  return (await get(`${API.LINE_ITEMS}/${id}`)) as LineItem;
};

export const updateLineItem = async (id: string, lineItem: LineItem) => {
  return (await put(`${API.LINE_ITEMS}/${id}`, lineItem)) as LineItem;
};
export const bulkUpdateLineItems = async (lineItems: LineItem[], divisionId: string | null) => {
  return await put(`${API.LINE_ITEMS}/bulk-update?divisionId=${divisionId}`, lineItems);
};
export const addOrUpdateNote = async (divisionId: string, reportId: string, noteDTO: NoteDTO) => {
  const response = await post(`${API.DIVISIONS}/Note/?divisionId=${divisionId}&reportId=${reportId}`, noteDTO);
};
export const getAllLineItems = async () => {
  return await get(`${API.LINE_ITEMS}/GetAllLineItems`);
};
export const predictDivisions = async (lineItems: LineItemForPrediction[]) => {
  const divisionMapperHost = process.env.REACT_APP_DIVISION_MAPPER_HOST;
  if (!divisionMapperHost) {
    throw new Error('REACT_APP_DIVISION_MAPPER_HOST environment variable is not defined');
  }

  let results: LineItemForPrediction[] = [];
  await fetch(`${divisionMapperHost}/predict`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(lineItems),
  })
    .then(response => response.json())
    .then(data => {
      results = data;
    });

  return results;
};
